import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DivButton from '../DivButton/DivButton.jsx'
import rootActions from 'actions/rootActions'
import InputGroupText from '../inputGroupText/InputGroupText.jsx'

class DeletePresetDialog extends React.Component {
  constructor() {
    super()

    this.state = {
      value: null
    }
  }
  presetName = () => {
    const name = this.state.name
    const highlight =
      name === undefined || name === ''
        ? { borderColor: 'red' }
        : {}
    return (
      <InputGroupText
        aria-label={'preset name'}
        title="Name"
        value={name}
        stretch={true}
        placeholder=""
        style={{ ...highlight, textAlign: 'right' }}
        onChange={e => {
          this.setState({ name: e.target.value })
        }}
      />
    )
  }
  render() {
    const highlight = !this.state.value ? 'red-border' : ''
    const options = this.props.presets.map((preset, index) => {
      return ({
        label: preset.name,
        value: preset.name
      })
      }
    )
    return (
      <div className="standard-modal-content">
        <div className="message-content">
          <div style={{ marginBottom: '70px', width: '40%' }}>
            <br />
            Choose preset to delete:
            <br />
            <br />
            <div style={{fontSize: '14px', width: '100%' }}>
              <InputGroupText
                type={'select'}
                options={options}
                aria-label={'preset dropdown'}
                title="Preset name"
                value={this.state.value}
                placeholder={this.state.value || 'Name...'}
                menuHeight={'120px'}
                valueClassName={highlight}
                titleClassName={highlight}
                onChange={option => {
                  this.setState({value: option.value})
                }}
              />
            </div>
          </div>
        </div>
        <div className={'standard-modal-button-container'}>
          <DivButton
            className={'btn btn-danger'}
            aria-label={`modal cancel button`}
            onClick={this.props.closeSelf}
          >
            Cancel
          </DivButton>
          <DivButton
            className={'btn btn-success'}
            aria-label={`modal download button`}
            disabled={!this.state.value}
            onClick={() => {
              this.props.okHandler(this.state.value)
              this.props.closeSelf()
            }}
          >
            Delete
          </DivButton>
        </div>
      </div>
    )
  }
}

DeletePresetDialog.propTypes = {
  // callback function for okButton
  okHandler: PropTypes.func,
  // callback function for cancel button
  cancelHandler: PropTypes.func,
  count: PropTypes.number,
  totalRows: PropTypes.number,
  pageSize: PropTypes.number,
  maxPageSize: PropTypes.number
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(rootActions, dispatch)
}

export default connect(null, mapDispatchToProps)(DeletePresetDialog)
